export class Verifiable {

    constructor(
        public verified: boolean = false){
    }

}